// VAPID application server key for web push. The PUBLIC key is not a secret — it's handed to the
// browser's PushManager. The matching private key is a Cloud Functions secret, never in this bundle.
export const VAPID_PUBLIC_KEY = 'BERrC_PY83EMpH3VSpVXUsUG-zLT6N0tSOpUqoUMu2miouURkZ9PD8bplW7xsrVY8gJWYVmdDi09ZAHWyysoXsY'

// Firestore subcollection where a device's push subscription is stored, scoped to
// the signed-in user: users/{uid}/push_subscriptions/{subId}.
export const PUSH_SUBSCRIPTIONS_COLLECTION = 'push_subscriptions'
